import "@hotwired/turbo-rails"

import "./controllers/cctv/jquery_global"
import "jquery-ui-dist/jquery-ui"
import "./controllers/cctv/jQDateRangeSlider-withRuler-min.js"

import "./controllers/cctv/nanoplayer.5.min"

import "./controllers"
import "trix"

import "@rails/actiontext"
import "@rails/request.js"

import "@hotwired/turbo-rails"
import "./legacy/auto_theme"

import {Tooltip, Toast, Popover, Offcanvas, Modal} from 'bootstrap';
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()
Rails.start()
import './legacy/legacy_jquery'
import "./legacy/legacy"
import "chartkick/chart.js"

window.modal = Modal



import TomSelect from "tom-select";
window.TomSelect = TomSelect;



document.addEventListener('DOMContentLoaded', initTooltips);
document.addEventListener('turbo:render', initTooltips);

function initTooltips() {
  let tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });

  const offcanvasElementList = document.querySelectorAll('.offcanvas')
  const offcanvasList = [...offcanvasElementList].map(offcanvasEl => new Offcanvas(offcanvasEl))
}

document.addEventListener('DOMContentLoaded', initPopover);
document.addEventListener('turbo:render', initPopover);

function initPopover() {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
}